<div [id]="mapDivId" class="map-preview" style="height: 200px; width: 100%; border: 1px solid #e5e7eb;"></div>
<div id="popup" class="ol-popup">
    <div id="popup-content"></div>
  </div>
